import moment from "moment";
import { formateDate } from "./formats.js";

export function isValidCNPJ(value) {
 
    value = value.replace(/[^\d]+/g,'');
 
    if(value == '') return false;
     
    if (value.length != 14)
        return false;
 
    // Elimina CNPJs invalidos conhecidos
    if (value == "00000000000000" || 
        value == "11111111111111" || 
        value == "22222222222222" || 
        value == "33333333333333" || 
        value == "44444444444444" || 
        value == "55555555555555" || 
        value == "66666666666666" || 
        value == "77777777777777" || 
        value == "88888888888888" || 
        value == "99999999999999")
        return false;
         
        if (!value) return false

        // Aceita receber o valor como string, número ou array com todos os dígitos
        const validTypes =
          typeof value === 'string' || Number.isInteger(value) || Array.isArray(value)
      
        // Elimina valor em formato inválido
        if (!validTypes) return false
      
        // Guarda um array com todos os dígitos do valor
        const match = value.toString().match(/\d/g)
        const numbers = Array.isArray(match) ? match.map(Number) : []
      
        // Valida a quantidade de dígitos
        if (numbers.length !== 14) return false
        
        // Elimina inválidos com todos os dígitos iguais
        const items = [...new Set(numbers)]
        if (items.length === 1) return false
      
        // Cálculo validador
        const calc = (x) => {
          const slice = numbers.slice(0, x)
          let factor = x - 7
          let sum = 0
      
          for (let i = x; i >= 1; i--) {
            const n = slice[x - i]
            sum += n * factor--
            if (factor < 2) factor = 9
          }
      
          const result = 11 - (sum % 11)
      
          return result > 9 ? 0 : result
        }
      
        // Separa os 2 últimos dígitos de verificadores
        const digits = numbers.slice(12)
        
        // Valida 1o. dígito verificador
        const digit0 = calc(12)
        if (digit0 !== digits[0]) return false
      
        // Valida 2o. dígito verificador
        const digit1 = calc(13)
        return digit1 === digits[1]    
}

export function isValidCPF(cpf) {
    if (typeof cpf !== "string") return false
    cpf = cpf.replace(/[\s.-]*/igm, '')
    if (
        !cpf ||
        cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999" 
    ) {
        return false
    }
    var soma = 0
    var resto
    for (var i = 1; i <= 9; i++) 
        soma = soma + parseInt(cpf.substring(i-1, i)) * (11 - i)
    resto = (soma * 10) % 11
    if ((resto == 10) || (resto == 11))  resto = 0
    if (resto != parseInt(cpf.substring(9, 10)) ) return false
    soma = 0
    for (var i = 1; i <= 10; i++) 
        soma = soma + parseInt(cpf.substring(i-1, i)) * (12 - i)
    resto = (soma * 10) % 11
    if ((resto == 10) || (resto == 11))  resto = 0
    if (resto != parseInt(cpf.substring(10, 11) ) ) return false
    return true
}

export function isValidDate(input_date){
    input_date = formateDate(input_date);
    var year = moment(input_date.toString(), "DD/MM/YYYY").year();

    if (year < 1000 || year > 3000)
        return false;

    return moment(input_date.toString(), "DD/MM/YYYY", true).isValid();
}

export function isValidHourMinute(input_date){
    return moment(input_date.toString(), "HH:mm", true).isValid();
}

export function isValidDayMonth(input_date){
    return moment(input_date.toString(), "DD/MM", true).isValid();
}

export function onlyNumber(input_text){
    input_text = input_text.replace(/[^0-9]+/g, '');
    return input_text;
}

export function onlyAlphaNumericAndSpace(input_text){
    input_text = input_text.replace(/[^A-zÀ-ú0-9\w\s\&]/gi,'');
    return input_text;
}